// extracted by mini-css-extract-plugin
export default {"footer":"gTA95BHyCIfNjLRJl1Pl","content":"Wl2bDk57zgY9Z_2cCynT"};